import {  Card,  DialogActions, DialogContent, DialogTitle,  Grid, IconButton, Stack, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from "react-redux";
import MDButton from "components/MDButton";
import { useEffect, useRef, useState } from "react";
import defaultImage from 'assets/images/placeholder-image.png';
import { removeAfterLastDot } from "utilities/common";

const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
};

export default function MediaUploadModal({ closeModal }) {
    const { modalData } = useSelector(state => state.modal);
    const { fileMediaHandler = () => { }, imageContent, index, memberSection, cusClass= false } = modalData
    const [formData, setFormData] = useState({
        "url": "",
        "alt": "",
        'title': "",
        'description': ""
    })
    useEffect(() => {
        setFormData({
            "url": modalData?.data?.url,
            'title': removeAfterLastDot(modalData?.data?.title),
            'description': modalData?.data?.description || "",
            "alt": modalData?.data?.alt || "",
        })
    }, [modalData])

    const [errors, setErrors] = useState({})

    const mediaChangeHandler = (event) => {
        setErrors({
            "url": "",
            "alt": "",
            'title': "",
            'description': ""
        })
        setFormData((prevState) => ({
            ...prevState,  // Spread the previous state
            [event?.target?.name]: event?.target?.value  // Update the specific field
        }));
    }

    const validateReasons = () => {
        let isError = false
        let errors = {}
        if (!formData?.title?.trim()) {
            isError = true
            errors = { ...errors, title: 'Title  is required' }
        }
   
        if (!formData?.url?.trim()) {
            isError = true
            errors = { ...errors, url: 'Image  is required' }
        }
    
        return { errors, isError }
    }

    const submitHandler = () => {
        const { isError, errors } = validateReasons()
        setErrors(errors)
        if (isError) return;
        setErrors({})
        fileMediaHandler(formData, imageContent, index, memberSection)
        closeModal()
    }

    return (
        <Card sx={{ p: 4, borderRadius: 0 }} className={cusClass ? "cus-dialog-small" : ""}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 3 }} display='flex' alignItems='center' justifyContent='space-between'>
                Media Information
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                <Grid container alignItems='center' spacing={{ xs: 3, md: 3 }}>
                    <Grid item xs={12}>
                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} mb={2} className="small-size">
                            <img key={formData?.url} style={uploadThumbnailImage} src={formData?.url || defaultImage} alt='documentId' />
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            autoComplete='off'
                            fullWidth
                            helperText={errors?.title}
                            error={errors?.title}
                            label={'Title'}
                            name='title'
                            onChange={(e) => mediaChangeHandler(e)}
                            className='form-input'
                            value={formData?.title || ''}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            autoComplete='off'
                            fullWidth
                            helperText={errors?.alt}
                            error={errors?.alt}
                            label={'Alt Tag'}
                            name='alt'
                            onChange={(e) => mediaChangeHandler(e)}
                            className='form-input'
                            value={formData?.alt || ''}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            autoComplete='off'
                            fullWidth
                            helperText={errors?.description}
                            error={errors?.description}
                            label={'Description'}
                            name='description'
                            onChange={(e) => mediaChangeHandler(e)}
                            className='form-input'
                            value={formData?.description || ''}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 0, mt: 4 }} style={{ justifyContent: "start" }}>
                <MDButton sx={{ minWidth: '160px' }} type='button' variant='contained' color='primary' onClick={() => submitHandler()}>
                    Save
                </MDButton>
                <MDButton sx={{ minWidth: '160px' }} type='button' variant='outlined' color='dark' className='dark-outlined-btn' onClick={() => closeModal()}>
                    Cancel
                </MDButton>
            </DialogActions>
        </Card>
    )
}